import { Text } from 'src/design/atoms/Text';
import { IconInfoCircle } from '@tabler/icons-react';
import React from 'react';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';
import { DisclosurePopover } from 'src/design/molecules/DisclosurePopover';

/** @registry Small info icon with a popover disclosing that chat conversations are retained/reviewable by admins; shown in the chat footer. */
export const RetentionNotice = React.memo(() => (
  <DisclosurePopover
    label="Data retention notice"
    position="top"
    content={
      <Text size="xs">
        Conversations are retained and may be reviewed by administrators.
      </Text>
    }
  >
    <BasicActionIcon
      variant="subtle"
      color="gray"
      size="sm"
      data-testid="retention-notice"
    >
      <IconInfoCircle size={16} />
    </BasicActionIcon>
  </DisclosurePopover>
));
